import { createRoute } from "@tanstack/solid-router";
import { savedViewRoute } from "./views.$viewId";

export const savedViewTodoRoute = createRoute({
  getParentRoute: () => savedViewRoute,
  path: "/todo/$todoId",
  component: SavedViewTodoDetailRoutePage,
});

function SavedViewTodoDetailRoutePage() {
  return null;
}
